import script from "./ApplicationStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationStatus.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationStatus.vue?vue&type=style&index=0&id=2ba0150c&lang=scss"

const __exports__ = script;

export default __exports__